import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import Header from "./Header";
import CollapsiblePanel from "./CollapsiblePanel";
import History from "./History";
import Parameters from "./Parameters";
import Splines from "./Splines";
import DataInput from "./DataInput";
import { getInitialState } from "./DefaultParameters";

/**
 * Prediction tab layout. Calls POST /api/v1/microslide/predict.
 */
export default function PredictionLayout() {
    const [resultsCollapsed, setResultsCollapsed] = useState(true);
    const [dataCollapsed, setDataCollapsed] = useState(false);
    const [splinesCollapsed, setSplinesCollapsed] = useState(true);
    const [paramsCollapsed, setParamsCollapsed] = useState(true);

    const [rows, setRows] = useState([{ sampleId: "", response1: "", response2: "" }]);
    const [parameters, setParameters] = useState(getInitialState());
    const [splines, setSplines] = useState({
        preprocessing: null, g1: null, g2: null, g3: null, g4: null
    });

    const [resultDataMap, setResultDataMap] = useState(() => {
        const saved = sessionStorage.getItem("microslideHistory_predict");
        return saved ? JSON.parse(saved) : {};
    });

    useEffect(() => {
        if (resultDataMap && Object.keys(resultDataMap).length > 0) {
            setResultsCollapsed(false);
        }
    }, [resultDataMap]);

    return (
        <div>
            <Header
                mode="predict"
                rows={rows}
                parameters={parameters}
                setParameters={setParameters}
                extras={{ splines }}
                setResultDataMap={setResultDataMap}
                onRun={() => setResultsCollapsed(false)}
            />

            <Box display="flex" flexDirection="column" padding={2}>
                <CollapsiblePanel
                    title="Results"
                    collapsed={resultsCollapsed}
                    onToggle={() => setResultsCollapsed(!resultsCollapsed)}
                >
                    <History
                        resultDataMap={resultDataMap}
                        resultFields={["Sample Count", "First Concentration", "Last Concentration"]}
                    />
                </CollapsiblePanel>

                <CollapsiblePanel
                    title="Sample Data (one row per sample)"
                    collapsed={dataCollapsed}
                    onToggle={() => setDataCollapsed(!dataCollapsed)}
                >
                    <DataInput
                        columns={[
                            { key: "sampleId", label: "Sample ID" },
                            { key: "response1", label: "Response 1" },
                            { key: "response2", label: "Response 2" }
                        ]}
                        rows={rows}
                        setRows={setRows}
                        placeholder={"SampleID\tResp1\tResp2\n1\t0.5\t0.25\n2\t0.7\t0.35\n..."}
                    />
                </CollapsiblePanel>

                <CollapsiblePanel
                    title="Splines"
                    collapsed={splinesCollapsed}
                    onToggle={() => setSplinesCollapsed(!splinesCollapsed)}
                >
                    <Splines splines={splines} setSplines={setSplines} />
                </CollapsiblePanel>

                <CollapsiblePanel
                    title="Assay Parameters"
                    collapsed={paramsCollapsed}
                    onToggle={() => setParamsCollapsed(!paramsCollapsed)}
                >
                    <Parameters parameters={parameters} setParameters={setParameters} />
                </CollapsiblePanel>
            </Box>
        </div>
    );
}
